export const ProjectSqlContentCountFields = `
  sqlModels {
    _id
  }
  jobs {
    _id
  }
  sqlSources {
    _id
  }
  sqlMacros {
    _id
  }
  sqlSeeds {
    _id
  }
`;
export const ProjectContentCountFields = `
  pipelines {
    _id
  }
  gems {
    _id
  }
  jobs {
    _id
  }
  datasets {
    _id
  }
  subgraphs {
    _id
  }
`;
